<div class="combined-form">
    <!-- Organization Section -->
    <div class="section-header">
        <h3>Organization Details</h3>
        <p>Tell us about your organization</p>
    </div>
    <form [formGroup]="organizationInfoForm">
        <div class="row">
            <div class="col-md-6">
                <label class="visually-hidden" for="onboarding-org-name">Organization Name</label>
                <mat-form-field appearance="outline">
                    <mat-label>Organization Name</mat-label>
                    <input matInput id="onboarding-org-name" formControlName="name" (blur)="onOrganizationNameChange()">
                    <mat-error>This field is required.</mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <label class="visually-hidden" for="onboarding-org-domain">Domain</label>
                <mat-form-field appearance="outline">
                    <mat-label>Domain</mat-label>
                    <input matInput id="onboarding-org-domain" formControlName="domain" />
                    <span matTextSuffix class="domain-suffix">.membertrace.com</span>
                    <mat-icon *ngIf="!(isChecking$ | async)" matSuffix matTooltip="This is your unique subdomain. It will appear as your-domain.membertrace.com">
                      help
                    </mat-icon>
                    <mat-progress-spinner
                    *ngIf="isChecking$ | async"
                    matSuffix
                    diameter="20"
                    mode="indeterminate">
                  </mat-progress-spinner>
                    <mat-error *ngIf="organizationInfoForm.controls['domain'].errors?.['domainTaken']">
                        This domain is already taken.
                    </mat-error>
                    <mat-error *ngIf="organizationInfoForm.controls['domain'].hasError('pattern')">
                        Invalid domain. Use only letters, numbers, and dashes.
                    </mat-error>
                    <mat-error *ngIf="organizationInfoForm.controls['domain'].hasError('required')">
                        This field is required.
                    </mat-error>
                    <mat-error *ngIf="organizationInfoForm.controls['domain'].hasError('apiError')">
                        Domain check is temporarily unavailable. Please try again in a moment.
                    </mat-error>
                    <mat-hint *ngIf="organizationInfoForm.get('domain')?.valid && !(isChecking$ | async)">✓ This domain is available</mat-hint>
                  </mat-form-field>
            </div>
            <div class="col-md-6">
                <mat-form-field appearance="outline">
                    <mat-label>Industry</mat-label>
                    <mat-select id="onboarding-org-industry" formControlName="industry" placeholder="Select your industry">
                        <mat-option *ngFor="let industry of industries" [value]="industry">
                            {{ industry }}
                        </mat-option>
                    </mat-select>
                    <mat-error>This field is required.</mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>

    <!-- Administrator Section -->
    <div class="section-header mt-4">
        <h3>Administrator Account</h3>
        <p>Create your admin account to manage your organization</p>
    </div>
    <form [formGroup]="adminInfoForm">
        <div class="row">
            <div class="col-md-6">
                <label class="visually-hidden" for="onboarding-admin-first-name">First Name</label>
                <mat-form-field appearance="outline">
                    <mat-label>First Name</mat-label>
                    <input matInput id="onboarding-admin-first-name" formControlName="firstName">
                    <mat-error>This field is required.</mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <label class="visually-hidden" for="onboarding-admin-last-name">Last Name</label>
                <mat-form-field appearance="outline">
                    <mat-label>Last Name</mat-label>
                    <input matInput id="onboarding-admin-last-name" formControlName="lastName">
                    <mat-error>This field is required.</mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <label class="visually-hidden" for="onboarding-admin-email">Email</label>
                <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput id="onboarding-admin-email" formControlName="email" type="email">
                    <mat-error *ngIf="adminInfoForm.controls['email'].hasError('required')">This field is required.</mat-error>
                    <mat-error *ngIf="adminInfoForm.controls['email'].hasError('email')">Please enter a valid email.</mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <label class="visually-hidden" for="onboarding-admin-password">Password</label>
                <mat-form-field appearance="outline">
                    <mat-label>Password</mat-label>
                    <input matInput id="onboarding-admin-password" [type]="hidePassword ? 'password' : 'text'" formControlName="password">
                    <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button" [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'">
                        <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                    <mat-hint>At least 8 characters with uppercase, lowercase, number, and special character (!&#64;#$%^&amp;*-).</mat-hint>
                    <mat-error *ngIf="adminInfoForm.controls['password'].hasError('required')">This field is required.</mat-error>
                    <mat-error *ngIf="adminInfoForm.controls['password'].hasError('minlength')">Password must be at least 8 characters.</mat-error>
                    <mat-error *ngIf="adminInfoForm.controls['password'].hasError('missingUppercase')">Password must include at least one uppercase letter.</mat-error>
                    <mat-error *ngIf="adminInfoForm.controls['password'].hasError('missingLowercase')">Password must include at least one lowercase letter.</mat-error>
                    <mat-error *ngIf="adminInfoForm.controls['password'].hasError('missingNumber')">Password must include at least one number.</mat-error>
                    <mat-error *ngIf="adminInfoForm.controls['password'].hasError('missingSpecialCharacter')">Password must include at least one special character: !&#64;#$%^&amp;*-.</mat-error>
                </mat-form-field>
            </div>
            <div class="col-md-6">
                <label class="visually-hidden" for="onboarding-admin-phone">Phone (Optional)</label>
                <mat-form-field appearance="outline">
                    <mat-label>Phone (Optional)</mat-label>
                    <input matInput id="onboarding-admin-phone" formControlName="phone" type="tel">
                    <mat-hint>We'll only use this for account recovery</mat-hint>
                </mat-form-field>
            </div>
        </div>
    </form>
</div>
